import styled from 'styled-components';

const ToolbarContainer = styled.div`
  height: auto;

  .toolbar-input-wrapper {
    margin: 5px;
    input {
      margin: 0;
      width: 100%;
      padding: 5px;
      height: auto;
      font-size: 1.5rem;
    }
  }
`;

export const EmbedderContainer = styled(ToolbarContainer)``;
export const ImageContainer = styled(ToolbarContainer)``;
export const InputTitle = styled.span`
  display: block;
  font-size: 1.3rem;
  font-weight: 600;
`;
